import { useState } from "react";

export const faqs = [
  {
    question: "Intervenez-vous rapidement à Haguenau ?",
    answer:
      "Oui, nos techniciens se déplacent régulièrement à Haguenau et dans le nord du Bas-Rhin. Pour les urgences, nous intervenons dans les meilleurs délais. Pour les interventions programmées, nous fixons un rendez-vous adapté à votre disponibilité.",
  },
  {
    question: "Le déplacement est-il payant à Haguenau ?",
    answer:
      "Non, le déplacement et le diagnostic sont gratuits à Haguenau comme dans tout le Bas-Rhin. Vous ne payez que les réparations réalisées, après acceptation du devis. Aucun frais caché.",
  },
  {
    question: "Réparez-vous toutes les marques de volets roulants à Haguenau ?",
    answer:
      "Oui, nous réparons toutes les marques de volets roulants : Somfy, Nice, Bubendorff, Profalux, Simu, Becker et bien d'autres. Qu'il s'agisse d'un volet manuel ou motorisé, nous disposons des pièces et du savoir-faire nécessaires.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold text-brand-blue mb-3">
            Questions fréquentes — Haguenau
          </h2>
          <p className="text-brand-text text-base md:text-lg">
            Retrouvez les réponses aux questions les plus courantes.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-white rounded-xl border border-brand-border overflow-hidden"
            >
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between p-5 md:p-6 text-left"
              >
                <span className="text-brand-blue font-semibold text-base pr-4">
                  {faq.question}
                </span>
                <div className="w-8 h-8 flex items-center justify-center shrink-0">
                  <i
                    className={`ri-arrow-down-s-line text-brand-cyan text-xl transition-transform ${
                      open === i ? "rotate-180" : ""
                    }`}
                  ></i>
                </div>
              </button>
              {open === i && (
                <div className="px-5 md:px-6 pb-5 md:pb-6">
                  <p className="text-brand-text text-sm leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}